import { render, staticRenderFns } from "./DeleteAppliance.vue?vue&type=template&id=589b3933"
import script from "./DeleteAppliance.vue?vue&type=script&lang=js"
export * from "./DeleteAppliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports